<deletemodal id="customer-tabs" [deleteModal]="deleteModal"></deletemodal>
<!-- <section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section> -->
<modal #accountNotification>
    <modal-header>
        <div class="color-blue">{{'customer-service.ACCOUNT NOTIFICATION' |translate}}</div>
    </modal-header>
    <modal-content *ngIf="notification">
        <div class="distributorInfo">
            <div>
                <span class="header-font bold">{{notification | displayNameFormat}}
                </span>
            </div>
            <div *ngIf="notification.displayName && notification.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{notification.displayName | titlecase}}</span>
              </div>
            <div>
                <a *ngIf="notification?.id"><i class="fa fa-copy" [copyToClipboard]="notification.id"></i></a>
                <span>{{notification.id |distributorIdFormat}} </span>
                <span *ngIf="notification.memberLevel"> | </span>
                <span>{{notification.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="accountNotification-content modalcontent-section">
            <div class="mt-40 notificationSubject">
                <span *ngIf="notification.subject">{{notification.subject}}</span>
            </div>
            <div class="mt-20 notificationBody">

                <span *ngIf="notification.body">{{notification.body}}</span>
            </div>
        </div>
        <div class="pull-right pad-r-8">
            <button class="btn blue-button" tabindex="0" type="button"
                (click)="closePopUpforAccountNotificationChange()">
                {{'order.OK' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>
<!-- <div> -->
        <tabset #findAccountTabs class="nav nav-tabs admin-tab cs-primary-tabs find-account__tabs cs-member-primary-tabs"
                    [justified]="justifyingTabs">
            <tab autofocus id="customer-search" class="padding0" (select)="onSelect()" [active]="activeTab===1"
                heading="{{'customer-service.Find Account' |translate |translateKey}}" [removable]="false">
                <div class="container">
                    <customer-search></customer-search>
                </div>
            </tab>
            
            <tab [removable]="false" id="left-arrow-tab" [disabled]="!tabs?.length"  class="padding0" [active]="!activeTab">
                <ng-template tabHeading>
                    <span class="fa fa-angle-left">&nbsp;</span>
                </ng-template>
            </tab>
            <tab [removable]="false"  id="right-arrow-tab"  [disabled]="!tabs?.length" class="padding0" [active]="!activeTab">
                <ng-template tabHeading>
                    <span class="fa fa-angle-right">&nbsp;</span>
                </ng-template>
            </tab>
        </tabset>
        <tabset #dashboardTabs class="nav nav-tabs admin-tab cs-primary-tabs cs-member-tabs dashboard-member__tabs"
            [justified]="justifyingTabs" customCarousel>
            
            <tab autofocus id="customer-search" [disabled]="true" [class.display-none]="!tabs?.length" customClass="padding0 visibility-hidden" (select)="onSelect()"
                heading="{{'customer-service.Find Account' |translate |translateKey}}" [removable]="false">
                <div class="container">
                    <!-- <customer-search></customer-search> -->
                </div>
            </tab>

            <tab [removable]="false" id="left-arrow-tab"  (click)="onClick($event)" customClass="padding0 visibility-hidden" [active]="false">
                <ng-template tabHeading>
                    <span class="fa fa-angle-left">&nbsp;</span>
                </ng-template>
            </tab>
            <tab [removable]="false"  id="right-arrow-tab"  (click)="onClick($event)" customClass="padding0 visibility-hidden" [active]="false">
                <ng-template tabHeading>
                    <span class="fa fa-angle-right">&nbsp;</span>
                </ng-template>
            </tab>
            <tab class="dynamic-tab padding0" *ngFor="let tabz of tabs" [active]="activeTab === tabz.activeTab" [id]="tabz.id"
                (select)="tabSelected(tabz)" (deselect)="tabz.active = false" [disabled]="tabz.disabled"
                [removable]="tabz.removable" (removed)="removeTabHandler(tabz)">
                <ng-template tabHeading>
                    <span placement="bottom" title="{{tabz.title | titleCase}}">{{tabz.title | titleCase}}</span>
                </ng-template>
                <div class="">
                    <fbodetail-dashboard *ngIf="tabz.componentName == 'fboPage'" [fboinputvalue]="tabz.id"
                        [orderNumber]="tabz.orderNumber" [webOrderNumber]="tabz.webOrderNumber" [country]="tabz.country"
                        [isNewOrder]="tabz.isNewOrder" [memberType]="tabz.memberType" [orderType]="tabz.orderType"
                        [count]="count" (closeTabForFboID)='closeParticularTabForDistributorId($event)'>
                    </fbodetail-dashboard>
                </div>
                <retail-template *ngIf="tabz.componentName == 'retailPage'" retailerid={{tabz.id}}></retail-template>
            </tab>
        </tabset>
    <!-- </div> -->


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/dynamic-tabs.component.html